import { render, staticRenderFns } from "./MedicineComponent.vue?vue&type=template&id=639b755c&"
import script from "./MedicineComponent.vue?vue&type=script&lang=js&"
export * from "./MedicineComponent.vue?vue&type=script&lang=js&"
import style0 from "./MedicineComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports